import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import apisCreateMerchants from '@/pages/activity-manage/merchants/create-merchants/apis';
import { queryDucc } from '@/apis/marketingField/materialCollection';
import { getQuery } from '@/common/utils';
import { useConfig } from '@/apis/ducc';
import env from '@/env';

const newPandoraConfig = React.createContext([]);

// const poolTypes = '17,23,27,28,29,40,42,48,90,101,110,120,147,148,32,124,55,123,18,122,19,49,45'.split(',');

function NewPandora(props) {
  const [poolIDSInNew, setPoolIDSInnew] = useState([]);
  const [getConfig] = useConfig();

  useEffect(() => {
    queryDucc({
      duccKey: env.ACE_DUCC_KEY,
    }).then((res) => {
      setPoolIDSInnew((res?.data?.data ?? '').split(','));
    });
  }, []);

  const contextData = useMemo(() => {
    const panoraTransform = (getConfig('pandoraTransform') || '').split(',');

    return {
      loading: !(panoraTransform && poolIDSInNew.length),
      poolTypes: poolIDSInNew,
      newInPlanCodeJumpToPandora: panoraTransform.includes('1'),
      newInChannelRuleSetting: panoraTransform.includes('2'),
      newInChannelJumpToPandora: panoraTransform.includes('3'),
    };
  }, [getConfig, poolIDSInNew]);

  return <newPandoraConfig.Provider value={contextData}>{props.children || null}</newPandoraConfig.Provider>;
}

function usePandoraLink(poolType, oldLink, newLink) {
  const poolTypes = useContext(newPandoraConfig);

  return newPandoraLink(poolType, poolTypes, oldLink, newLink);
}

// 分为几种情况
// 1. 收品池设置和非收品池设置
// 2. 主题活动和非主题活动
// 3. 每种情况都对应有开关
function newPandoraLink(poolType, poolTypes, oldLink, newLink) {
  if (!poolType || poolType.loading) return oldLink;

  const atPlanCode = window.location.href.indexOf('/activity-manage/merchants') !== -1;
  if (atPlanCode) {
    if (poolTypes.newInPlanCodeJumpToPandora) {
      if (poolTypes.poolTypes.includes(poolType + '')) return newLink;
      return oldLink;
    } else {
      return oldLink;
    }
  } else {
    // 选品规则
    if (
      (poolType === 44 && typeof oldLink === 'function') ||
      window.location.href.indexOf('/material-poolrule-new') !== -1
    ) {
      return poolTypes.newInChannelRuleSetting ? newLink : oldLink;
    } else {
      // 判断是选品规则还是跳转潘多拉选品
      if (poolTypes.newInChannelJumpToPandora) {
        return poolTypes.poolTypes.includes(poolType + '') ? newLink : oldLink;
      } else {
        return oldLink;
      }
    }
  }
}

const defaultOnIdChange = function () {};
// type 1 主题活动 2频道和阵地
function useRuleId(type = 2, channelId, onIdChange = defaultOnIdChange) {
  const ruleIdRef = useRef({});

  useEffect(() => {
    let activityCode, channelType, poolType;
    if (type === 1) {
      activityCode = channelId || getQuery('planCode');
      channelType = 1;
      poolType = 12;
    } else {
      activityCode = channelId || getQuery('channelId') || getQuery('roomId');
      channelType = 2;
      poolType = 44;
    }
    apisCreateMerchants.activitySelectRuleQuerySelectRuleId({ activityCode, channelType, poolType }).then((res) => {
      const { ret, data } = res;

      if (ret !== '0') return onIdChange();
      ruleIdRef.current = data.ruleId;
      onIdChange(data.ruleId);
    });
    // eslint-disable-next-line
  }, [type, channelId]);

  return ruleIdRef;
}

export default NewPandora;

export { newPandoraConfig, usePandoraLink, newPandoraLink, useRuleId };
